import { useEffect } from "react";
import axios from "axios";

import { Prices } from "../models/CurrencyPair";
import { updatePrices, updateTime } from "../zustand/priceStore";
import environment from "../utils/Environment";

interface Result {
	data: Prices;
}

const useLatestFXRate = () => {
	useEffect(() => {
		refreshData();

		const interval = setInterval(() => {
			refreshData();
		}, 60000);

		return () => clearInterval(interval);
	});

	const fetchData = async () => {
		const result: Result = await axios(environment.MFX_BASE_URL);
		return result;
	};

	const refreshData = () => {
		fetchData().then((result: Result) => {
			if (result.data.prices && result.data.prices.length > 0) {
				updateTime(result.data.pricesGeneratedAt);
				updatePrices(result.data.prices);
			}
		});
	};
};

export default useLatestFXRate;
